import axios from 'axios';


const url = '/api/configuration/user-in-project';

export const getList = ({ q, projectId } = {}) => axios.get(`${url}/users`, {
    params: { q, projectId },
})
    .then(response => response.data);



// WEBPACK FOOTER //
// ../utils/api/configuration/user-in-project.js